<template>
  <div class="HeatTreatmentInquire">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div style="width:100vw">
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">歷史參數查詢</span>
              </b-col>
              <commonQueryIoT />
              <heatTreatmentInquireResult />
            </b-col>
            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import heatTreatmentInquireResult from "@/components/heatTreatmentInquireResult.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "HeatTreatmentInquire",
  data() {
    return {};
  },
  created: function() {
    let vm = this;
    // vm.getSelectOption();
    vm.setCommonQueryData();
    vm.setQueryInput();
  },
  mounted: function() {
    let vm = this;
    if (vm.fromWorkOrderHistoryParams.from) {
      let params = {};
      let startTime = vm.fromWorkOrderHistoryParams.start;
      let endTime = vm.fromWorkOrderHistoryParams.end;
      let device = vm.fromWorkOrderHistoryParams.device;
      let htProcess = vm.fromWorkOrderHistoryParams.htProcess;
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["whichFunction"] = "MainQuery";
      params["deviceID"] = device;
      params["htProcess"] = htProcess;
      params["startTime"] = startTime;
      params["endTime"] = endTime;
      params["fromWorkOrderHistory"] = true;
      vm.show_loadScreenModal();
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result);
        vm.change_tableBusy();
        if (result["Response"] == "ok") {
          vm.set_queryResponse(result["QueryTableData"]);
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
          vm.set_queryResponse("查無資料");
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
          vm.set_queryResponse(result["Response"]);
        }
      });
    }
  },
  components: {
    commonQueryIoT,
    heatTreatmentInquireResult
  },
  watch: {
    commonQueryResponse: {
      handler() {
        let vm = this;
        if (
          vm.commonQueryResponse == "查無資料" ||
          vm.commonQueryResponse == "時間尚未選擇"
        ) {
          return;
        }
        vm.set_heatTreatmentInquireResultItem(
          vm.commonQueryResponse.information
        );
        vm.set_htWorkValueFields(vm.commonQueryResponse.htWorkValueFields);
        vm.set_htWorkValueItem(vm.commonQueryResponse.value);
        vm.setExportCsvData(
          vm.commonQueryResponse.value,
          vm.commonQueryResponse.information
        );
      }
    }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      commonQueryResponse: "commonqueryiot/get_queryResponse",
      fromWorkOrderHistoryParams:
        "heatTreatmentInquireResult/get_fromWorkOrderHistoryParams",
      htWorkValueFields: "heatTreatmentInquireResult/get_htWorkValueFields"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_tableBusy: "commonqueryiot/change_tableBusy",
      show_loadScreenModal: "loadscreenmodal/show_loadScreenModal",
      hide_loadScreenModal: "loadscreenmodal/hide_loadScreenModal",
      set_queryResponse: "commonqueryiot/set_queryResponse",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_processOption: "commonqueryiot/set_processOption",
      set_deviceOption: "commonqueryiot/set_deviceOption",
      set_groupOption: "commonqueryiot/set_groupOption",
      set_htWorkValueFields: "heatTreatmentInquireResult/set_htWorkValueFields",
      set_heatTreatmentInquireResultItem:
        "heatTreatmentInquireResult/set_heatTreatmentInquireResultItem",
      clear_heatTreatmentInquireResultItem:
        "heatTreatmentInquireResult/clear_heatTreatmentInquireResultItem",
      set_htWorkValueItem: "heatTreatmentInquireResult/set_htWorkValueItem",
      clear_htWorkValueItem: "heatTreatmentInquireResult/clear_htWorkValueItem",
      clear_fromWorkOrderHistoryParams:
        "heatTreatmentInquireResult/clear_fromWorkOrderHistoryParams",
      set_exportData: "exportcsv/set_exportData",
      set_exportDataTitle: "exportcsv/set_exportDataTitle",
      set_exportFileName: "exportcsv/set_exportFileName",
      set_exportExcelFileName: "exportcsv/set_exportExcelFileName",
      set_exportExcelData: "exportcsv/set_exportExcelData"
    }),
    setCommonQueryData() {
      let vm = this;
      vm.set_phpfunction("MainQuery");
    },
    setQueryInput() {
      let vm = this;
      vm.set_selectTag({
        startTime: true,
        endTime: false,
        startMinTime: true,
        endMinTime: true,
        htProcess: true,
        deviceCode: true,
        workCode: false
      });
      vm.set_selectTagCheck({
        startTime: true,
        endTime: false,
        startMinTime: true,
        endMinTime: true,
        process: false,
        htProcess: true,
        deviceCode: true,
        productCode: false,
        workCode: false
      });
    },
    getSelectOption() {
      let vm = this;
      var params = {};
      params["vuePage"] = "selectoption";
      params["methods"] = "GET";
      params["whichFunction"] = "SelectOption";
      console.log(params);
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.set_processOption(result.QueryTableData.process);
          vm.set_groupOption(result.QueryTableData.group);
          vm.set_deviceOption(result.QueryTableData.device);
        }
      });
    },
    clearExportCsv() {
      let vm = this;
      vm.set_exportData([]);
      vm.set_exportDataTitle([]);
      vm.set_exportFileName("");
    },

    setExportCsvData(valueData, infoData) {
      let vm = this;
      vm.clearExportCsv();
      let title = [];
      vm.htWorkValueFields.forEach(element => {
        title.push(element.label);
      });
      vm.set_exportDataTitle(title);

      let exportValue = [];
      let setValue = {};
      let actValue = {};
      valueData.forEach(element => {
        setValue = { time: element.time, group: "設定值" };
        setValue = Object.assign(setValue, element.value.set);
        exportValue.push(setValue);

        actValue = { time: element.time, group: "實際值" };
        actValue = Object.assign(actValue, element.value.act);
        exportValue.push(actValue);
      });
      vm.set_exportData(exportValue);
      let filename =
        "熱處理參數_" +
        infoData[0].device +
        "_" +
        infoData[0].date.replace(/-/g, "");
      vm.set_exportFileName(filename);
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    // this.clearTimer();
    let vm = this;
    vm.clear_heatTreatmentInquireResultItem();
    vm.clear_htWorkValueItem();
    vm.clear_fromWorkOrderHistoryParams();
    vm.clearExportCsv();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/heatTreatmentInquire.vue